
import React from 'react';
import Header from '@/components/layout/Header';
import CompareContainer from '@/components/compare/CompareContainer';

const Compare: React.FC = () => {
  return (
    <>
      <Header />
      <CompareContainer />
    </>
  );
};

export default Compare;
